export const PUBLIC_CLOUDFLARE_ACCOUNT_ID =
  process.env.NEXT_PUBLIC_CLOUDFLARE_ACCOUNT_ID

export const PUBLIC_CLOUDFLARE_ACCOUNT_HASH =
  process.env.NEXT_PUBLIC_CLOUDFLARE_ACCOUNT_HASH
